var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('transition',{attrs:{"name":"fade-transition"}},[_c('MyExamsComponent',{attrs:{"get-url":"/exams/homeworks/results"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }